import { persistReducer, persistStore } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { combineReducers, configureStore, type Reducer } from "@reduxjs/toolkit"
import billingReducer from "./billing/billingSlice"
import { type BillingState } from "./billing/types"
import productsReducer from "./product/productSlice"
import { type ProductState } from "./product/types"
import userReducer, { type IUserState } from "./user/userSlice"
import { getPersistConfig } from "redux-deep-persist"

export interface RootState {
  billing: BillingState
  user: IUserState
  products: ProductState
}

const rootReducer: Reducer<RootState> = combineReducers({
  billing: billingReducer,
  user: userReducer,
  products: productsReducer,
})

const persistConfig = getPersistConfig({
  key: "root-v2",
  storage,
  whitelist: ["user.userInfo", "user.customPhoto"],
  rootReducer,
})

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
})

export const persistor = persistStore(store)
export type AppDispatch = typeof store.dispatch
